import { DEFAULT_PAGE_SIZE } from "@/shared/constants/pagination";
import type { PaginationState } from "@tanstack/react-table";
import { useState } from "react";

export const useControlResultsPagination = (
  initialPageSize = DEFAULT_PAGE_SIZE,
) => {
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: initialPageSize,
  });

  return {
    pagination,
    setPagination,
    currentPage: pagination.pageIndex + 1,
    pageSize: pagination.pageSize,
  };
};
